import styled from '@emotion/styled';

import { css } from '@emotion/react';
import {
    gutterSizes,
    colorVariables,
    fontSizes,
    mediaQuery,
    breakpoints,
    fontWeights,
} from '@gumtree/ui-library/src/base/theme';

export const DesktopMotorsSpecsSection = styled.section`
    width: 100%;
    margin: ${gutterSizes.xlarge} 0;
    position: relative;
`;
interface TabHeaderContainerProps {
    indicatorLocation: {
        left: number;
        width: number;
    };
}
export const TabHeaderContainer = styled.div<TabHeaderContainerProps>`
    position: relative;
    display: flex;
    justify-items: flex-start;
    border-bottom: 1px solid ${colorVariables.borderLight};
    width: 100%;
    overflow: hidden;

    ${({ indicatorLocation: { left, width } }) =>
        width &&
        css`
            :after {
                content: '';
                position: absolute;
                left: ${left}px;
                width: ${width}px;
                bottom: 0;
                transition-duration: 400ms;
                height: 3px;
                background-color: ${colorVariables.textPrice};
            }
        `}
`;

export const marginBetweenTabTitles = 20;

export const TabTitle = styled.h4<{ activeTab: boolean; transformLeft?: number }>`
    padding: ${gutterSizes.medium} 0;
    color: ${colorVariables.textNeutral};
    margin: 0 ${marginBetweenTabTitles}px 0 0;
    font-weight: normal;
    line-height: 28px;
    text-align: center;
    transition: color 500ms ease, transform 400ms ease;
    border-bottom: 3px solid transparent;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    ${({ transformLeft }) =>
        css`
            transform: translateX(${transformLeft}px);
        `}

    ${({ activeTab }) =>
        activeTab &&
        css`
            color: ${colorVariables.textPrimary};
            font-weight: ${fontWeights.lightBold};
        `}

    ${mediaQuery.from(breakpoints.large)} {
        :hover {
            color: ${colorVariables.textPrimary};
        }
    }

    ${mediaQuery.between(breakpoints.medium, breakpoints.xlarge)} {
        font-size: ${fontSizes.base};
    }
`;
export const ContentContainer = styled.div`
    padding: ${gutterSizes.base} 0;
`;
export const UlContent = styled.ul<{ isAdditionalFeatures: boolean }>`
    list-style-type: none;
    width: 100%;
    margin: 0;
    padding: 0;
    column-count: ${({ isAdditionalFeatures }) => (isAdditionalFeatures ? 3 : 2)};
    column-width: ${({ isAdditionalFeatures }) => (isAdditionalFeatures ? 250 : 300)}px;
    column-fill: balance;
`;

export const Li = styled.li`
    display: flex;
    align-items: center;
    padding: ${gutterSizes.base} 0;
    break-inside: avoid;

    &.fade-enter {
        opacity: 0;
    }

    &.fade-enter-active {
        opacity: 1;
        transition: opacity 500ms ease-in-out;
    }

    &.fade-exit-active {
        display: none;
    }
`;

export const Name = styled.div<{ isAdditionalFeatures: boolean }>`
    font-size: ${fontSizes.base};
    color: ${colorVariables.textNeutral};
    width: ${({ isAdditionalFeatures }) => (isAdditionalFeatures ? 250 : 200)}px;
    text-align: left;
`;

export const Value = styled.div`
    font-weight: ${fontWeights.lightBold};
    text-align: left;
    color: ${colorVariables.textPrimary};
    white-space: pre-wrap;
`;

const MoreTabsButton = styled.button`
    position: absolute;
    top: 0;
    height: 55px;
    background: rgba(255, 255, 255, 0.6);
    color: ${colorVariables.textSecondary};
    border: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    transition: all 300ms ease;

    :hover,
    :focus {
        background-color: rgba(255, 255, 255, 0.9);
        color: ${colorVariables.textPrice};
        outline: none;
        font-weight: bold;
    }
`;

export const MoreTabsButtonRight = styled(MoreTabsButton)`
    right: 0;
    margin-right: -6px;
    padding-left: 0;
`;

export const MoreTabsButtonLeft = styled(MoreTabsButton)`
    left: 0;
    margin-left: -6px;
    padding-right: 0;
`;
